import { useNavigate } from "react-router-dom";
import { useQuestionGuides } from "./useQuestionGuides";
import { useTranslation } from "react-i18next";
import questionGuidesEntryImage from "@/assets/images/question-guides-entry.png";

export function QuestionGuidesEntryCard() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const categories = useQuestionGuides();

  if (categories.length === 0) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/question-guides")}
      className="dp-card flex min-h-[153px] w-full flex-col items-end justify-between gap-4 p-4 text-left transition-[border-color,box-shadow] hover:border-[var(--dp-brand-button)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--dp-brand-button)] focus-visible:ring-offset-2"
    >
      <div className="flex w-full items-start gap-4">
        <img alt="" className="h-[52px] w-[52px] shrink-0" src={questionGuidesEntryImage} />
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="text-lg font-semibold leading-[27px] text-[#0a0c11]">
            {t("questionGuides.title")}
          </span>
          <span className="text-sm leading-[21px] tracking-[0.07px] text-[#5b616d]">
            {t("questionGuides.subtitle")}
          </span>
        </span>
      </div>
      <span className="dp-button-secondary h-9 px-4 text-sm leading-5 text-[var(--dp-brand-deep)]">
        {t("questionGuides.view_guides")}
      </span>
    </button>
  );
}
